import { makeStyles } from '@material-ui/core';

export const useCasePlanCreateHeaderStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    padding: '24px 24px 24px 24px',
    boxSizing: 'border-box',
    borderBottom: `1px solid ${theme.palette.colors.grey60}`,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flex: 1,
  },
  backButton: {
    border: `1px solid ${theme.palette.colors.bluePrimaryMain}`,
    borderRadius: '100px',
    padding: '8px',
    color: theme.palette.colors.bluePrimaryMain,
    backgroundColor: theme.textWhite.main,
    '&:hover': {
      backgroundColor: theme.palette.colors.grey20,
    },
  },
  title: {
    color: theme.palette.primary.main,
    whiteSpace: 'nowrap',
  },
}));
